// extracted by mini-css-extract-plugin
export default {"title":"AddUtenteNew_title__tIylT","container":"AddUtenteNew_container__VZ8uC"};